export default /* glsl */`
    gl_FragColor.a = 1.0;
`;
